import TaxonomyPage from '@/pages/catalog/TaxonomyPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/catalog/taxonomy')({
  component: TaxonomyPage,
})
